import React, { ReactElement } from 'react';

export default function ChartTop(): ReactElement {
  return (
    <div id="chart-top" className="clearfix">
      <div id="chart-title" className="c-sidebar">
        <h1>Sjökort</h1>
      </div>
    </div>
  );
}
